import React, { Component } from 'react';
import { isEmpty, isNil, sortBy, prop } from 'ramda';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, CartesianGrid } from 'recharts';

import AdministrationPage from '../containers/AdministrationPage';
import BoardgameForm from './BoardgameForm';
import Error from './Error';

import placeIcon from '../assets/images/icon-plane.svg';

class AdminBoardgamePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.params.id,
      isEditMode: !isNil(props.params.id) && !isEmpty(props.params.id),
      requested: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getChartData = this.getChartData.bind(this);
  }

  componentDidMount() {
    if (this.state.isEditMode && !this.props.boardgame && !this.state.requested) {
      this.props.getBoardgame(this.props.params.id);
      this.setState({ requested: true });
    }

    if (this.state.isEditMode) {
      this.props.getBoardgameStatistics(this.props.params.id);
    }

    this.props.getCategories();
  }

  handleSubmit(values) {
    const bg = Object.assign({}, values, this.state.isEditMode ? {} : {
      visible: false,
      playsCount: 0,
      reservedCopies: 0,
    });

    bg.minPlayTime = parseInt(bg.minPlayTime, 10);
    bg.maxPlayTime = parseInt(bg.maxPlayTime, 10);
    bg.minPlayers = parseInt(bg.minPlayers, 10);
    bg.maxPlayers = parseInt(bg.maxPlayers, 10);
    bg.availableCopies = parseInt(bg.availableCopies, 10);
    bg.bggId = parseInt(bg.bggId, 10);

    if (this.state.isEditMode) {
      this.props.updateBoardgame(this.state.id, bg);
    } else {
      this.props.createBoardgame(bg);
    }
  }

  getChartData() {
    return sortBy(prop('day'), this.props.statistics || [])
      .map(observation => ({ 
        day: moment.unix(observation.day).format( 'DD/MM/YYYY'),
        plays: observation.plays
      }));
  }

  render() {
    if (this.state.isEditMode && this.state.requested && !this.props.loading && !this.props.boardgame) {
      return <Error
        title="Non abbiamo trovato il gioco che hai chiesto..."
        message="Forse ti sei perso mentre sfogliavi i regolamenti dei tuoi nuovi giochi."
        icon={placeIcon} />
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            { this.state.isEditMode ? ((this.props.boardgame && this.props.boardgame.title) || 'Caricamento...') : 'Nuovo titolo' } - Smart Gaming
          </title>
        </Helmet>
        <AdministrationPage>
          <BoardgameForm
            loading={this.props.loading}
            editMode={this.state.isEditMode}
            title={this.state.isEditMode ? 'Modifica titolo' : 'Nuovo titolo'}
            initialValues={this.state.isEditMode ? this.props.boardgame : { availableCopies: 1, minPlayers: 1, minPlayTime: 1 }}
            categories={this.props.categories}
            onSubmit={this.handleSubmit} />

          {
            this.state.isEditMode
              ? <div className="flex flex-wrap justify-center">
                  <div className="w-full max-w-lg relative bg-white px-6 py-6 mt-8 shadow rounded">
                    {
                      this.props.loadingStatistics
                        ? <h1 className="text-center text-2xl">Caricamento statistiche in corso...</h1>
                        : <ResponsiveContainer width="100%" height={400}>
                            <LineChart data={this.getChartData()}>
                              <CartesianGrid stroke="#eaeaea" />
                              <Line type="monotone" dot={true} dataKey="plays" stroke="#8884d8" />
                              <XAxis dataKey="day" />
                              <YAxis />
                            </LineChart>
                          </ResponsiveContainer>
                    }
                  </div>
                </div>
              : null
          }
        </AdministrationPage>
      </React.Fragment>
    );
  }
}

export default AdminBoardgamePage;
